import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../centerWarehouse/partnerInternalRequestApproval/ContextAPI';
import Index from '../centerWarehouse/partnerInternalRequestApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function PartnerInternalRequestCentralApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['partner-internal-request-central-approval'])
        return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
